export default [
    {
        path: 'setting/pipeline',
        name: 'pipelineConfig',
        meta: {
            requiresAuth: true
        },
        component: () => import('@/views/setting/Config')
    },
    {
        path: 'setting/formPage',
        name: 'pipelineForm',
        meta: {
            requiresAuth: true
        },
        component: () => import('@/views/setting/FormPage')
    },
];